export default "__VITE_ASSET__C2CycZdW__"